import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material'
import React from 'react'

export interface IAddNoticeProps {
  onConfirm: () => void
  onClose: () => void
  contentText: React.ReactElement | string
  title?: React.ReactElement | string
}

const AddNotice = ({
  onConfirm,
  onClose,
  contentText,
  title = `Внимание!`,
}: IAddNoticeProps) => {
  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{contentText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onConfirm}
          color="primary"
          autoFocus
          variant="contained"
        >
          Понятно
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddNotice
